<script setup lang="ts">
definePageMeta({ layout: "search" });
</script>

<template>
  <WorkersSearchPage />
</template>
